import { Menu, Button, MenuItem, Fade, Typography } from '@mui/material';
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Iconify from '../../../../../reusable-components/iconify';

SubticketsMenu.propTypes = {
  isTicketInfoOpen: PropTypes.bool,
}
export default function SubticketsMenu({isTicketInfoOpen}) {
  const { id = '' } = useParams();
  const [anchorEl, setAnchorEl] = useState(false);
  const isSubticketMenuOpen = Boolean(anchorEl);
  const location = useLocation();
  const subticketId = new URLSearchParams(location.search).get('subticket');
  const { subtickets, mainTicket } = useSelector((state) => state.tickets.data.ticketInfoById[id] || {});  
  const [displayedTicketId, setDisplayedTicketId] = useState(subticketId || id);

  useEffect(() => {
    setDisplayedTicketId(subticketId || id);
  }, [subticketId, id]);

  useEffect(() => {
    if(isTicketInfoOpen) {
      setAnchorEl(null);
    }
  }, [isTicketInfoOpen])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);
  
  const handleOptionClick = (id) => {
    setDisplayedTicketId(id);
    setAnchorEl(null);
  }

  const navigate = useNavigate();

  const navigateToMainTicket = () => {
    navigate(`/dashboard/tickets/${mainTicket.id}`);
  }

  const navigateToSubticket = (id) => { 
    navigate(`/dashboard/tickets/${mainTicket.id}?subticket=${id}`);
  }

  return <>{subtickets?.length > 0 ?
    <Button
      sx={{ fontWeight: 'bold', py: 0 }}
      id="fade-button"
      aria-controls={isSubticketMenuOpen ? 'fade-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={isSubticketMenuOpen ? 'true' : undefined}
      onClick={(e) => handleClick(e)}
      endIcon={isSubticketMenuOpen ?
        <Iconify icon='mdi:chevron-up'/> :
        <Iconify icon='mdi:chevron-down'/>}
    > 
      #{subtickets?.find(s => String(s.id) === String(displayedTicketId))?.ticketName || displayedTicketId}
    </Button> : <Typography color="primary">#{displayedTicketId}</Typography>}
    <Menu
      id="fade-menu"
      MenuListProps={{
        'aria-labelledby': 'fade-button',
      }}
      anchorEl={anchorEl}
      open={isSubticketMenuOpen}
      onClose={handleClose}
      TransitionComponent={Fade}
    >
      <MenuItem
        onClick={(e) => {
          handleOptionClick(e.target.value);
          navigateToMainTicket();
        }}
        value={mainTicket?.id}
        sx={(theme) => ({
          backgroundColor: String(displayedTicketId) === String(mainTicket?.id) ? theme.palette.primary.lightest : 'inherit'
        })}
      >{mainTicket?.id}</MenuItem>
      {subtickets?.map((t) => <MenuItem
        onClick={() => {
          handleOptionClick(t.id);
          navigateToSubticket(t.id);
        }}
        key={t.id}
        value={t.id}
        sx={(theme) => ({
          backgroundColor: String(displayedTicketId) === String(t.id) ? theme.palette.primary.lightest : 'inherit'
        })}
      >{t.ticketName}</MenuItem>)}
    </Menu>
  </>
}